<div
  *ngrxLet="isSelected$ as isSelected"
  class="rounded-md"
  [class.bg-gray-light]="isExpanded"
  [class.border]="isExpanded"
  [class.border-gray-border]="isExpanded"
  [class.mb-2]="isExpanded"
>
  <button
    class="w-full h-12 flex justify-between items-center cursor-pointer p-2"
    [class.bg-blue]="isSelected && !isExpanded"
    [class.border-b]="isExpanded"
    [class.border-gray-border]="isExpanded"
    (click)="toogleIsExpanded()"
    type="button"
    data-qa="filter-accordeon-expand"
  >
    <span
      class="italic text-gray-dark"
      [class.text-white]="isSelected && !isExpanded"
      [class.text-gray-dark]="!isSelected || isExpanded"
    >
      {{ filter.translationKey | transloco }}
    </span>
    <elio-svg-icon [@rotate]="isExpanded" [class.text-white]="isSelected && !isExpanded" key="chevron"></elio-svg-icon>
  </button>
  <div *ngIf="isExpanded" @vSlideInOut class="space-y-1 overflow-hidden mt-1">
    <elio-filter-item
      *ngFor="let singleFilter of filter.subFilters; trackBy: trackById"
      [filter]="singleFilter"
      [hasTranslation]="filter.hasTranslation"
    >
    </elio-filter-item>
  </div>
</div>
